import { render, staticRenderFns } from "./WorkAndFinances.vue?vue&type=template&id=ad94b674&scoped=true"
import script from "./WorkAndFinances.vue?vue&type=script&lang=js"
export * from "./WorkAndFinances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad94b674",
  null
  
)

export default component.exports